var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaritynavcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 672.3 196.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #414156;\n      }\n\n      .st1 {\n        fill: #00ca9f;\n      }\n\n      .st2 {\n        fill: #424156;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "445.3 76.1 403.6 25.1 387.5 25.1 387.5 109.1 406.7 109.1 406.7 58.1 448.6 109.1 464.5 109.1 464.5 25.1 445.3 25.1 445.3 76.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M510.9,25.1l-37.4,84h19.9l7.5-18h38.9l7.5,18h20.4l-37.6-84h-19.2ZM507,76.4l13.4-32.1,13.3,32.1h-26.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "625.3 25.1 599.3 85.1 573.8 25.1 552.8 25.1 589 109.1 608.2 109.1 644.6 25.1 625.3 25.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 207.4,
    y: 133.8,
    width: 3.9,
    height: 36.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.2,144c-1.7-.9-3.6-1.3-5.9-1.3s-4.9.6-6.8,1.7c-1.5.9-2.7,2.1-3.6,3.6v-5h-3.5v27.4h3.7v-14.4c0-2.1.4-3.9,1.2-5.3.8-1.5,1.9-2.6,3.3-3.4,1.4-.8,3.1-1.2,5.1-1.2s4.6.7,6.1,2.2c1.4,1.5,2.2,3.7,2.2,6.5v15.5h3.7v-15.9c0-2.6-.5-4.8-1.4-6.6-1-1.7-2.3-3-4-3.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 257.6,
    y: 142.9,
    width: 3.7,
    height: 27.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M259.5,131.6c-.8,0-1.4.3-1.9.8s-.8,1.1-.8,1.9.3,1.4.8,1.9c.5.5,1.2.8,1.9.8s1.4-.3,2-.8c.5-.5.8-1.2.8-1.9s-.3-1.3-.8-1.8c-.5-.5-1.2-.7-1.9-.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "290.6 145.3 290.6 142.9 269 142.9 269 146 285.9 146 268.7 167.9 268.7 170.3 291 170.3 291 167.2 273.4 167.2 290.6 145.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.2,131.6c-.8,0-1.4.3-1.9.8s-.8,1.1-.8,1.9.3,1.4.8,1.9c.5.5,1.2.8,1.9.8s1.4-.3,2-.8c.5-.5.8-1.2.8-1.9s-.3-1.3-.8-1.8c-.5-.5-1.2-.7-1.9-.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 298.3,
    y: 142.9,
    width: 3.7,
    height: 27.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M330.7,144.5c-2.1-1.2-4.5-1.8-7.2-1.8s-5.1.6-7.1,1.8-3.7,2.8-5,4.9c-1.2,2.1-1.8,4.5-1.8,7.2s.6,5.1,1.8,7.2c1.2,2.1,2.9,3.8,5,5s4.5,1.8,7.1,1.8,5.1-.6,7.2-1.8c2.1-1.2,3.8-2.9,5-5,1.2-2.1,1.8-4.5,1.8-7.2s-.6-5.2-1.8-7.2-2.9-3.7-5-4.9ZM332.4,162.2c-.9,1.6-2.1,2.9-3.6,3.8-1.5.9-3.3,1.3-5.3,1.3s-3.6-.4-5.2-1.3c-1.5-.9-2.7-2.1-3.6-3.8-.9-1.6-1.4-3.5-1.4-5.6s.5-4,1.4-5.6,2.1-2.8,3.6-3.7c1.5-.9,3.3-1.3,5.2-1.3s3.7.4,5.2,1.3c1.5.9,2.7,2.1,3.6,3.7s1.3,3.5,1.3,5.6-.4,4-1.3,5.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "370.5 163.4 347 133.8 343.8 133.8 343.8 170.3 347.7 170.3 347.7 140.7 371.1 170.3 374.3 170.3 374.3 133.8 370.5 133.8 370.5 163.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M395,142.7c-2.2,0-4.2.3-6.2,1-1.9.6-3.6,1.6-5,2.7l1.7,2.8c1.1-1,2.5-1.8,4.1-2.3,1.6-.6,3.3-.9,5.1-.9,2.6,0,4.5.6,5.8,1.9s2,3,2,5.4v1.7h-8.7c-2.6,0-4.7.4-6.2,1.1s-2.7,1.7-3.3,2.8c-.7,1.2-1,2.5-1,3.9s.4,2.9,1.2,4.1c.8,1.2,2,2.1,3.5,2.8,1.5.7,3.3,1,5.3,1s4.8-.5,6.5-1.6c1.3-.8,2.2-1.8,2.9-3v4.3h3.5v-17c0-3.6-1-6.2-2.9-8-1.9-1.8-4.7-2.6-8.2-2.6ZM399.1,166.2c-1.5,1-3.3,1.4-5.4,1.4s-3.9-.5-5.1-1.4c-1.2-.9-1.8-2.2-1.8-3.8s.5-2.6,1.5-3.5c1-.9,2.9-1.4,5.5-1.4h8.6v4.5c-.7,1.8-1.8,3.2-3.3,4.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "424.7 166.3 414.4 142.9 410.5 142.9 422.7 170.3 426.5 170.3 438.7 142.9 435 142.9 424.7 166.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 443.9,
    y: 142.9,
    width: 3.7,
    height: 27.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M445.8,131.6c-.8,0-1.4.3-1.9.8s-.8,1.1-.8,1.9.3,1.4.8,1.9c.5.5,1.2.8,1.9.8s1.4-.3,2-.8c.5-.5.8-1.2.8-1.9s-.3-1.3-.8-1.8c-.5-.5-1.2-.7-1.9-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.8,148.1c-1.1-1.7-2.5-3-4.3-3.9-1.9-1-4.1-1.5-6.6-1.5s-5,.6-7,1.7-3.7,2.7-4.9,4.7-1.8,4.3-1.8,6.9.6,4.9,1.8,6.9,2.8,3.6,4.9,4.7,4.4,1.7,7,1.7,4.6-.5,6.6-1.6c1.7-.9,3-2.2,4.1-3.8v3.5c0,3.4-.8,5.9-2.5,7.5-1.6,1.6-4.2,2.4-7.7,2.4s-4.1-.3-6-1c-1.9-.7-3.5-1.6-4.8-2.7l-1.9,2.8c1.4,1.4,3.3,2.4,5.6,3.1,2.3.7,4.7,1.1,7.2,1.1,4.5,0,7.9-1.1,10.2-3.3,2.3-2.2,3.5-5.7,3.5-10.4v-24h-3.5v5.2ZM474.7,164.7c-1.6.9-3.4,1.3-5.4,1.3s-3.8-.4-5.3-1.3c-1.6-.9-2.8-2-3.7-3.5-.9-1.5-1.3-3.3-1.3-5.2s.4-3.7,1.3-5.2c.9-1.5,2.1-2.7,3.7-3.5,1.6-.9,3.4-1.3,5.3-1.3s3.8.4,5.4,1.3c1.6.9,2.8,2,3.7,3.5s1.4,3.2,1.4,5.2-.5,3.7-1.4,5.2c-.9,1.5-2.1,2.7-3.7,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M503.2,142.7c-2.2,0-4.2.3-6.2,1-1.9.6-3.6,1.6-5,2.7l1.7,2.8c1.1-1,2.5-1.8,4.1-2.3,1.6-.6,3.3-.9,5.1-.9,2.6,0,4.5.6,5.8,1.9s2,3,2,5.4v1.7h-8.7c-2.6,0-4.7.4-6.2,1.1s-2.7,1.7-3.3,2.8c-.7,1.2-1,2.5-1,3.9s.4,2.9,1.2,4.1c.8,1.2,2,2.1,3.5,2.8,1.5.7,3.3,1,5.3,1s4.8-.5,6.5-1.6c1.3-.8,2.2-1.8,2.9-3v4.3h3.5v-17c0-3.6-1-6.2-2.9-8-1.9-1.8-4.7-2.6-8.2-2.6ZM507.3,166.2c-1.5,1-3.3,1.4-5.4,1.4s-3.9-.5-5.1-1.4c-1.2-.9-1.8-2.2-1.8-3.8s.5-2.6,1.5-3.5c1-.9,2.9-1.4,5.5-1.4h8.6v4.5c-.7,1.8-1.8,3.2-3.3,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M533.5,167.4c-1.5,0-2.7-.4-3.5-1.3-.8-.9-1.2-2.1-1.2-3.7v-16.4h8.3v-3.1h-8.3v-6h-3.7v6h-4.9v3.1h4.9v16.6c0,2.5.7,4.5,2.1,5.9,1.4,1.4,3.4,2.1,5.9,2.1s2.1-.2,3.2-.5c1-.3,1.9-.8,2.6-1.5l-1.3-2.7c-1.1.9-2.4,1.4-4.1,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M563,144.5c-2.1-1.2-4.5-1.8-7.2-1.8s-5.1.6-7.1,1.8-3.7,2.8-5,4.9c-1.2,2.1-1.8,4.5-1.8,7.2s.6,5.1,1.8,7.2c1.2,2.1,2.9,3.8,5,5s4.5,1.8,7.1,1.8,5.1-.6,7.2-1.8c2.1-1.2,3.8-2.9,5-5,1.2-2.1,1.8-4.5,1.8-7.2s-.6-5.2-1.8-7.2-2.9-3.7-5-4.9ZM564.6,162.2c-.9,1.6-2.1,2.9-3.6,3.8-1.5.9-3.3,1.3-5.3,1.3s-3.6-.4-5.2-1.3c-1.5-.9-2.7-2.1-3.6-3.8-.9-1.6-1.4-3.5-1.4-5.6s.5-4,1.4-5.6,2.1-2.8,3.6-3.7c1.5-.9,3.3-1.3,5.2-1.3s3.7.4,5.2,1.3c1.5.9,2.7,2.1,3.6,3.7s1.3,3.5,1.3,5.6-.4,4-1.3,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M580.8,148.3v-5.4h-3.5v27.4h3.7v-14c0-3.2.8-5.7,2.5-7.5s3.9-2.6,6.8-2.6.3,0,.4,0c.1,0,.3,0,.4,0v-3.6c-2.7,0-4.9.5-6.7,1.6-1.6.9-2.7,2.3-3.5,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M598,164.9c-.8,0-1.4.3-2,.8-.5.5-.8,1.2-.8,2s.3,1.5.8,2c.5.6,1.2.8,2,.8s1.4-.3,2-.8c.5-.6.8-1.2.8-2s-.3-1.5-.8-2c-.5-.5-1.2-.8-2-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M618.8,142.7c-2.2,0-4.2.3-6.2,1-1.9.6-3.6,1.6-5,2.7l1.7,2.8c1.1-1,2.5-1.8,4.1-2.3,1.6-.6,3.3-.9,5.1-.9,2.6,0,4.5.6,5.8,1.9s2,3,2,5.4v1.7h-8.7c-2.6,0-4.7.4-6.2,1.1s-2.7,1.7-3.3,2.8c-.7,1.2-1,2.5-1,3.9s.4,2.9,1.2,4.1c.8,1.2,2,2.1,3.5,2.8,1.5.7,3.3,1,5.3,1s4.8-.5,6.5-1.6c1.3-.8,2.2-1.8,2.9-3v4.3h3.5v-17c0-3.6-1-6.2-2.9-8-1.9-1.8-4.7-2.6-8.2-2.6ZM622.9,166.2c-1.5,1-3.3,1.4-5.4,1.4s-3.9-.5-5.1-1.4c-1.2-.9-1.8-2.2-1.8-3.8s.5-2.6,1.5-3.5c1-.9,2.9-1.4,5.5-1.4h8.6v4.5c-.7,1.8-1.8,3.2-3.3,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M643.8,132.4c-.5-.5-1.2-.7-1.9-.7s-1.4.3-1.9.8-.8,1.1-.8,1.9.3,1.4.8,1.9c.5.5,1.2.8,1.9.8s1.4-.3,2-.8c.5-.5.8-1.2.8-1.9s-.3-1.3-.8-1.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 640,
    y: 142.9,
    width: 3.7,
    height: 27.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.9,39.5c3.2-3.2,7-5.6,11.3-7.3,4.3-1.7,9-2.6,14-2.6s9.3.8,13.4,2.3c4.2,1.6,8,4.1,11.4,7.6l5.6-5.6c-3.7-4.1-8.2-7.1-13.6-9.2-5.4-2-11.1-3.1-17.2-3.1s-12.2,1.1-17.5,3.2c-5.4,2.1-10,5.1-14,8.9-4,3.8-7,8.4-9.2,13.6-2.2,5.2-3.3,10.9-3.3,17s1.1,11.8,3.3,17c2.2,5.2,5.3,9.7,9.2,13.6,3.9,3.8,8.6,6.8,13.9,8.9,5.4,2.1,11.2,3.2,17.5,3.2s11.9-1,17.3-3.1c5.4-2.1,9.9-5.2,13.6-9.2l-5.6-5.6c-3.4,3.5-7.2,6.1-11.4,7.7-4.2,1.6-8.6,2.4-13.4,2.4s-9.7-.9-14-2.6c-4.3-1.7-8.1-4.2-11.3-7.3-3.2-3.2-5.7-6.8-7.5-11-1.8-4.2-2.7-8.8-2.7-13.9s.9-9.7,2.7-13.9c1.8-4.2,4.3-7.9,7.5-11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 111.3,
    y: 17.4,
    width: 8.5,
    height: 89
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.1,42.8c-5,0-9.7.7-14.2,2.2-4.5,1.5-8.3,3.6-11.5,6.3l3.8,6.4c2.6-2.2,5.7-4,9.4-5.4,3.7-1.4,7.6-2,11.6-2,5.9,0,10.4,1.4,13.4,4.3,3,2.9,4.5,7,4.5,12.4v3.8h-20c-6,0-10.8.8-14.3,2.5-3.6,1.6-6.1,3.8-7.7,6.5-1.6,2.7-2.3,5.7-2.3,8.9s.9,6.8,2.8,9.5c1.8,2.8,4.5,4.9,8,6.5,3.5,1.6,7.6,2.3,12.3,2.3s11-1.2,14.9-3.7c2.9-1.8,5.1-4.1,6.8-6.8v9.9h8.2v-39.1c0-8.2-2.2-14.4-6.7-18.4-4.4-4-10.7-6.1-18.9-6.1ZM173.5,97c-3.5,2.2-7.6,3.3-12.4,3.3s-9-1.1-11.8-3.2c-2.8-2.2-4.2-5-4.2-8.6s1.2-5.9,3.5-8c2.4-2.2,6.6-3.2,12.7-3.2h19.8v10.3c-1.6,4.2-4.1,7.3-7.6,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.4,55.6v-12.2h-8.2v63h8.5v-32.2c0-7.4,1.9-13.2,5.6-17.2,3.8-4,9-6.1,15.6-6.1s.6,0,1,0c.3,0,.6,0,1,0v-8.3c-6.2,0-11.3,1.3-15.5,3.8-3.6,2.2-6.2,5.2-8,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.1,17.4c-1.8,0-3.2.6-4.4,1.7-1.2,1.2-1.8,2.6-1.8,4.3s.6,3.1,1.8,4.3c1.2,1.2,2.7,1.8,4.4,1.8s3.3-.6,4.5-1.8c1.2-1.2,1.7-2.7,1.7-4.4s-.6-3.1-1.8-4.2c-1.2-1.1-2.7-1.7-4.4-1.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 248.8,
    y: 43.4,
    width: 8.5,
    height: 63
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.8,96.4c-2.5,2.2-5.6,3.2-9.4,3.2s-6.2-1-8.1-3c-1.9-2-2.8-4.8-2.8-8.5v-37.7h19.2v-7.1h-19.2v-13.9h-8.5v13.9h-11.3v7.1h11.3v38.2c0,5.8,1.6,10.4,4.8,13.6,3.2,3.2,7.8,4.8,13.7,4.8s4.9-.4,7.3-1.1c2.4-.7,4.4-1.8,6.1-3.4l-3-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.1,43.4l-23.7,53.5-23.8-53.5h-8.9l28.2,62.8-2.7,6.2c-1.8,3.9-3.8,6.7-5.8,8.2-2,1.6-4.5,2.3-7.3,2.3s-4.4-.4-6.3-1.3c-1.9-.8-3.6-2-5.2-3.5l-4,6.4c1.9,1.9,4.2,3.4,6.9,4.3,2.7,1,5.5,1.4,8.5,1.4s5.8-.5,8.3-1.5c2.5-1,4.8-2.7,6.9-5.1,2.1-2.4,4.1-5.6,5.8-9.7l31.6-70.6h-8.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaritynavcard);
export default __webpack_public_path__ + "static/media/claritynavcard.43369c2774a6fcf02b17024152b6bea0.svg";
export { ForwardRef as ReactComponent };